module.exports = __webpack_public_path__ + "static/media/coupe4.47f69d5e.jpg";